export  function downloadPdf(base64, fileName = "documento.pdf") {
  if (typeof base64 !== "string" || !base64.trim()) {
    throw new Error("O conteúdo Base64 está vazio ou é inválido.");
  }


  // Remover prefixo de Data URL, se existir
  let cleanBase64 = normalizeBase64Pdf(base64)
    .trim()
    .replace(/^data:application\/pdf;base64,/i, "")
    .replace(/\s/g, "");

  // Converter Base64 URL-safe para Base64 convencional
  cleanBase64 = cleanBase64
    .replace(/-/g, "+")
    .replace(/_/g, "/");
cleanBase64 = cleanBase64.replace(/\\u002B/gi, "+")
    .replace(/\\u002F/gi, "/")
    .replace(/\\u003D/gi, "=")
    .replace(/\s/g, "");
  // Corrigir padding em falta
  const remainder = cleanBase64.length % 4;

  if (remainder === 1) {
    throw new Error("A string Base64 parece estar truncada ou malformada.");
  }

  if (remainder > 0) {
    cleanBase64 += "=".repeat(4 - remainder);
  }

  const binaryString = atob(cleanBase64);
  const bytes = new Uint8Array(binaryString.length);

  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  const blob = new Blob([bytes], {
    type: "application/pdf",
  });

  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.download = fileName;

  document.body.appendChild(link);
  link.click();
  link.remove();

  // Libertar a URL depois de o navegador iniciar o download
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}


function diagnoseBase64Pdf(input) {
  const issues = [];
  const warnings = [];

  if (typeof input !== "string") {
    return {
      valid: false,
      issues: [
        `Tipo inválido: esperado string, recebido ${typeof input}.`,
      ],
    };
  }

  if (!input.length) {
    return {
      valid: false,
      issues: ["A string está vazia."],
    };
  }

  let base64 = input.trim();

  // Remover prefixo Data URL
  if (/^data:/i.test(base64)) {
    const match = base64.match(
      /^data:application\/pdf;base64,/i
    );

    if (!match) {
      issues.push(
        "O prefixo Data URL não corresponde a application/pdf;base64."
      );
    } else {
      base64 = base64.slice(match[0].length);
    }
  }

  // Verificar escapes JSON literais
  if (/\\u[0-9a-f]{4}/i.test(base64)) {
    warnings.push(
      "Existem sequências Unicode literais, como \\u002B. " +
      "Se forem escapes JSON, a string pode não ter sido descodificada."
    );

    base64 = base64.replace(/\\u([0-9a-f]{4})/gi, (_, hex) =>
      String.fromCharCode(parseInt(hex, 16))
    );
  }

  // Remover espaços e quebras de linha
  if (/\s/.test(base64)) {
    warnings.push(
      "Foram encontrados espaços ou quebras de linha; foram removidos."
    );
    base64 = base64.replace(/\s/g, "");
  }

  // Normalizar Base64 URL-safe
  if (/[-_]/.test(base64)) {
    warnings.push(
      "Foi detetado Base64 URL-safe; '-' e '_' foram convertidos."
    );
    base64 = base64.replace(/-/g, "+").replace(/_/g, "/");
  }

  // Verificar caracteres inválidos
  const invalid = /[^A-Za-z0-9+/=]/g;
  let match;

  while ((match = invalid.exec(base64)) !== null) {
    issues.push(
      `Carácter inválido "${match[0]}" na posição ${match.index}.`
    );

    if (issues.length >= 10) {
      issues.push("Diagnóstico limitado aos primeiros 10 erros.");
      break;
    }
  }

  if (issues.length) {
    return {
      valid: false,
      issues,
      warnings,
    };
  }

  // Validar padding
  if (/=/.test(base64.slice(0, -2))) {
    issues.push(
      'O carácter "=" aparece numa posição inválida.'
    );
  }

  if (base64.length % 4 === 1) {
    issues.push(
      `Comprimento inválido: ${base64.length} caracteres (resto 1 ao dividir por 4).`
    );
  }

  if (issues.length) {
    return {
      valid: false,
      issues,
      warnings,
    };
  }

  // Tentar descodificar
  let binary;

  try {
    const remainder = base64.length % 4;

    if (remainder > 0) {
      base64 += "=".repeat(4 - remainder);
    }

    binary = atob(base64);
  } catch (error) {
    return {
      valid: false,
      issues: [
        `Falha no atob(): ${error.message}`,
      ],
      warnings,
    };
  }

  // Verificar assinatura PDF
  const signature = binary.slice(0, 5);

  if (signature !== "%PDF-") {
    issues.push(
      `O conteúdo descodificado não começa com "%PDF-". Assinatura encontrada: ${JSON.stringify(signature)}.`
    );
  }

  // Verificar marcador final comum do PDF
  if (!binary.includes("%%EOF")) {
    warnings.push(
      'Não foi encontrado o marcador "%%EOF". O PDF pode estar incompleto ou usar uma estrutura não convencional.'
    );
  }

  return {
    valid: issues.length === 0,
    issues,
    warnings,
    base64Length: base64.length,
    decodedBytes: binary.length,
    signature,
  };
}
function normalizeBase64Pdf(input) {
  let base64 = input.trim();

  // Se a string inteira estiver entre aspas JSON,
  // tentar descodificá-la como string JSON.
  if (base64.startsWith('"') && base64.endsWith('"')) {
    try {
      base64 = JSON.parse(base64);
    } catch {
      throw new Error("A string entre aspas não é um JSON válido.");
    }
  }

  // Remover prefixo Data URL, se existir.
  base64 = base64.replace(
    /^data:application\/pdf;base64,/i,
    ""
  );

  // Remover espaços e quebras de linha.
  base64 = base64.replace(/\s/g, "");

  // Normalizar Base64 URL-safe.
  base64 = base64
    .replace(/-/g, "+")
    .replace(/_/g, "/");

  return base64;
}